// @flow
import * as React from "react";

import ButtonComponent from "components/Button";
import { StopOutlined } from "@ant-design/icons";

import "./styles.scss";

const ErrorBoundary = (props) => {
  const { errorInfo } = props;
  return (
      <div className="page-not-found" data-test="page-not-found">
          <StopOutlined className="icon" />
          <h2 className="title">Error </h2>
          <ButtonComponent
              onClick={() => window.location.reload(window.location.origin)}
              name="Home"
          />
      </div>
  );
};

export { ErrorBoundary as default };
